// Traduções da Anomalia Frota, até 04/11/2026 Anomalia Noturna, coletadas por glob em
// core/i18n/messages.ts. As chaves seguem com o prefixo de origem.
export default {
  pt: {
    'frotaLeve.anomalias.titulo': 'Anomalia Frota',
    'frotaLeve.anomalias.eyebrow': 'Gestão',
    'frotaLeve.anomalias.regra': 'Ligado na noite',
    'frotaLeve.anomalias.ajuda': 'Veículo da frota leve classificada ligado entre as {{de}} e as {{ate}}, na hora local de onde estava. O veículo sem classificação não entra. Conta só o trecho dentro da janela, a partir de {{min}} minutos. A noite é a data do início da janela. Com uma posição a cada 5 minutos, cada ponta tem erro de até 5 minutos.',
    'frotaLeve.anomalias.ajuda.pesada': 'Caminhão ligado entre as {{de}} e as {{ate}}, na hora local de onde estava, fora da carga do HUB. Não conta o carregando, o trânsito e a descarga, os Outros Serviços, a prancha e o Escalado perto do horário da carga, com 10 minutos de folga em cada ponta. Conta só o trecho fora deles, a partir de {{min}} minutos.',
    'frotaLeve.anomalias.ajuda.maquina': 'Máquina ligada entre as {{de}} e as {{ate}}, na hora local de onde estava, fora do período programado no Maquinário da frente. O período vai do primeiro ao último dia de colheita da máquina, e cobre a madrugada seguinte ao último. Conta a partir de {{min}} minutos.',
    'frotaLeve.anomalias.kpi.ocorrencias': 'Ocorrências',
    'frotaLeve.anomalias.kpi.veiculos': 'Veículos',
    'frotaLeve.anomalias.kpi.horas': 'Horas ligado',
    'frotaLeve.anomalias.kpi.km': 'Km na noite',
    'frotaLeve.anomalias.kpi.semMotorista': 'Sem cartão de motorista: {{n}}',
    'frotaLeve.anomalias.grafico.porNoite': 'Por noite',
    'frotaLeve.anomalias.grafico.porHora': 'Por hora local',
    'frotaLeve.anomalias.grafico.ocorrencias': 'Ocorrências',
    'frotaLeve.anomalias.grafico.minutos': 'Tempo ligado',
    'frotaLeve.anomalias.grafico.noite': 'Noite de {{dia}}: {{n}} ocorrências, {{horas}}, {{km}}',
    'frotaLeve.anomalias.grafico.hora': '{{hora}}: {{horas}} ligado',
    'frotaLeve.anomalias.grafico.vazio': 'Nenhuma ocorrência no período',
    'frotaLeve.anomalias.ranking.veiculos': 'Veículos mais ligados',
    'frotaLeve.anomalias.ranking.motoristas': 'Motoristas mais ligados',
    'frotaLeve.anomalias.ranking.vazio': 'Nada no período',
    'frotaLeve.anomalias.lista': 'Ocorrências',
    'frotaLeve.anomalias.vazio': 'Nenhum veículo ligado na noite neste filtro',
    'frotaLeve.anomalias.filtro.de': 'De',
    'frotaLeve.anomalias.filtro.ate': 'Até',
    'frotaLeve.anomalias.filtro.placa': 'Placa',
    'frotaLeve.anomalias.filtro.classificacao': 'Classificação',
    'frotaLeve.anomalias.filtro.motorista': 'Motorista',
    'frotaLeve.anomalias.filtro.filial': 'Filial',
    'frotaLeve.anomalias.filtro.todas': 'Todas',
    'frotaLeve.anomalias.col.veiculo': 'Veículo',
    'frotaLeve.anomalias.col.motorista': 'Motorista',
    'frotaLeve.anomalias.col.noite': 'Noite',
    'frotaLeve.anomalias.col.horario': 'Horário local',
    'frotaLeve.anomalias.col.ligado': 'Ligado',
    'frotaLeve.anomalias.col.km': 'Km',
    'frotaLeve.anomalias.semMotorista': 'Sem cartão',
    'frotaLeve.anomalias.semClassificacao': 'Sem classificação',
    'frotaLeve.anomalias.noite': '{{de}} a {{ate}}',
    'frotaLeve.anomalias.horario': '{{de}} às {{ate}}',
    'frotaLeve.anomalias.km.odometro': 'Pela diferença do odômetro, em {{pontos}} posições',
    'frotaLeve.anomalias.km.rastro': 'Pelo rastro das posições, {{pontos}} no trecho',
    'frotaLeve.anomalias.km.sem': 'Sem km: as posições não bastaram',
    'frotaLeve.anomalias.fuso.uf': 'Fuso pela UF da posição',
    'frotaLeve.anomalias.fuso.coordenada': 'Fuso pela coordenada da posição',
    'frotaLeve.anomalias.fuso.filial': 'Fuso pela filial do cadastro',
    'frotaLeve.anomalias.fuso.padrao': 'Fuso de Brasília, sem posição nem filial',
    'frotaLeve.anomalias.export.dica': 'Baixa as ocorrências do filtro',
    'frotaLeve.anomalias.export.vazio': 'Nenhuma ocorrência para baixar',
    'frotaLeve.anomalias.vezes': '{{n}}x',
    'frotaLeve.anomalias.aba.pesada': 'Frota Pesada',
    'frotaLeve.anomalias.aba.leve': 'Frota Leve',
    'frotaLeve.anomalias.aba.maquina': 'Máquina',
    'frotaLeve.anomalias.abas': 'Tipo de frota',
    'frotaLeve.anomalias.kpi.caminhoes': 'Caminhões',
    'frotaLeve.anomalias.kpi.maquinas': 'Máquinas',
    'frotaLeve.anomalias.kpi.semMotoristaPesada': 'Sem motorista: {{n}}',
    'frotaLeve.anomalias.kpi.semOperador': 'Sem operador: {{n}}',
    'frotaLeve.anomalias.kpi.recortadas': 'Encostadas na viagem: {{n}}',
    'frotaLeve.anomalias.ranking.caminhoes': 'Caminhões mais ligados',
    'frotaLeve.anomalias.ranking.maquinas': 'Máquinas mais ligadas',
    'frotaLeve.anomalias.ranking.operadores': 'Operadores mais ligados',
    'frotaLeve.anomalias.col.operador': 'Operador',
    'frotaLeve.anomalias.filtro.operador': 'Operador',
    'frotaLeve.anomalias.semMotoristaPesada': 'Sem motorista',
    'frotaLeve.anomalias.semOperador': 'Sem operador',
    'frotaLeve.anomalias.vazio.pesada': 'Nenhum caminhão ligado fora da carga neste filtro',
    'frotaLeve.anomalias.vazio.maquina': 'Nenhuma máquina ligada fora da programação neste filtro',
    'frotaLeve.anomalias.recorte.pesada': 'Fora da carga',
    'frotaLeve.anomalias.recorte.maquina': 'Fora da programação',
    'frotaLeve.anomalias.recorte.dica.pesada': 'A sessão encostou numa carga do HUB. Conta só o trecho fora dela.',
    'frotaLeve.anomalias.recorte.dica.maquina': 'A sessão encostou no período programado no Maquinário. Conta só o trecho fora dele.',
    'frotaLeve.anomalias.motoristaFonte.cartao': 'Pelo cartão do rastreador',
    'frotaLeve.anomalias.motoristaFonte.macro': 'Pela macro do motorista no rastreador',
    'frotaLeve.anomalias.motoristaFonte.conjunto': 'Pelo conjunto do cavalo no HUB',
    'frotaLeve.anomalias.motoristaFonte.operador': 'Pelo operador da máquina no Maquinário',
    'frotaLeve.anomalias.frente': 'Frente {{n}}',
  },
  en: {
    'frotaLeve.anomalias.titulo': 'Fleet Anomaly',
    'frotaLeve.anomalias.eyebrow': 'Management',
    'frotaLeve.anomalias.regra': 'On at night',
    'frotaLeve.anomalias.ajuda': 'Classified light fleet vehicle switched on between {{de}} and {{ate}}, in the local time where it was. Unclassified vehicles are left out. Only the stretch inside the window counts, from {{min}} minutes on. The night is the date the window starts. With one position every 5 minutes, each end may be off by up to 5 minutes.',
    'frotaLeve.anomalias.ajuda.pesada': 'Truck switched on between {{de}} and {{ate}}, in the local time where it was, outside a HUB load. Loading, transit and unloading, Other Services, the lowboy and the Scheduled status near the load time do not count, with 10 minutes of slack at each end. Only the stretch outside them counts, from {{min}} minutes on.',
    'frotaLeve.anomalias.ajuda.maquina': 'Machine switched on between {{de}} and {{ate}}, in the local time where it was, outside the period scheduled in the work front Machinery. The period runs from the first to the last harvest day of the machine, and covers the early morning after the last one. Counts from {{min}} minutes on.',
    'frotaLeve.anomalias.kpi.ocorrencias': 'Occurrences',
    'frotaLeve.anomalias.kpi.veiculos': 'Vehicles',
    'frotaLeve.anomalias.kpi.horas': 'Hours on',
    'frotaLeve.anomalias.kpi.km': 'Km at night',
    'frotaLeve.anomalias.kpi.semMotorista': 'No driver card: {{n}}',
    'frotaLeve.anomalias.grafico.porNoite': 'By night',
    'frotaLeve.anomalias.grafico.porHora': 'By local hour',
    'frotaLeve.anomalias.grafico.ocorrencias': 'Occurrences',
    'frotaLeve.anomalias.grafico.minutos': 'Time on',
    'frotaLeve.anomalias.grafico.noite': 'Night of {{dia}}: {{n}} occurrences, {{horas}}, {{km}}',
    'frotaLeve.anomalias.grafico.hora': '{{hora}}: {{horas}} on',
    'frotaLeve.anomalias.grafico.vazio': 'No occurrences in the period',
    'frotaLeve.anomalias.ranking.veiculos': 'Vehicles most often on',
    'frotaLeve.anomalias.ranking.motoristas': 'Drivers most often on',
    'frotaLeve.anomalias.ranking.vazio': 'Nothing in the period',
    'frotaLeve.anomalias.lista': 'Occurrences',
    'frotaLeve.anomalias.vazio': 'No vehicle on at night for this filter',
    'frotaLeve.anomalias.filtro.de': 'From',
    'frotaLeve.anomalias.filtro.ate': 'To',
    'frotaLeve.anomalias.filtro.placa': 'Plate',
    'frotaLeve.anomalias.filtro.classificacao': 'Classification',
    'frotaLeve.anomalias.filtro.motorista': 'Driver',
    'frotaLeve.anomalias.filtro.filial': 'Branch',
    'frotaLeve.anomalias.filtro.todas': 'All',
    'frotaLeve.anomalias.col.veiculo': 'Vehicle',
    'frotaLeve.anomalias.col.motorista': 'Driver',
    'frotaLeve.anomalias.col.noite': 'Night',
    'frotaLeve.anomalias.col.horario': 'Local time',
    'frotaLeve.anomalias.col.ligado': 'On',
    'frotaLeve.anomalias.col.km': 'Km',
    'frotaLeve.anomalias.semMotorista': 'No card',
    'frotaLeve.anomalias.semClassificacao': 'Unclassified',
    'frotaLeve.anomalias.noite': '{{de}} to {{ate}}',
    'frotaLeve.anomalias.horario': '{{de}} to {{ate}}',
    'frotaLeve.anomalias.km.odometro': 'From the odometer difference, over {{pontos}} positions',
    'frotaLeve.anomalias.km.rastro': 'From the position track, {{pontos}} in the stretch',
    'frotaLeve.anomalias.km.sem': 'No km: not enough positions',
    'frotaLeve.anomalias.fuso.uf': 'Time zone from the position state',
    'frotaLeve.anomalias.fuso.coordenada': 'Time zone from the position coordinates',
    'frotaLeve.anomalias.fuso.filial': 'Time zone from the registered branch',
    'frotaLeve.anomalias.fuso.padrao': 'Brasília time, no position or branch',
    'frotaLeve.anomalias.export.dica': 'Downloads the occurrences in the filter',
    'frotaLeve.anomalias.export.vazio': 'No occurrences to download',
    'frotaLeve.anomalias.vezes': '{{n}}x',
    'frotaLeve.anomalias.aba.pesada': 'Heavy Fleet',
    'frotaLeve.anomalias.aba.leve': 'Light Fleet',
    'frotaLeve.anomalias.aba.maquina': 'Machine',
    'frotaLeve.anomalias.abas': 'Fleet type',
    'frotaLeve.anomalias.kpi.caminhoes': 'Trucks',
    'frotaLeve.anomalias.kpi.maquinas': 'Machines',
    'frotaLeve.anomalias.kpi.semMotoristaPesada': 'No driver: {{n}}',
    'frotaLeve.anomalias.kpi.semOperador': 'No operator: {{n}}',
    'frotaLeve.anomalias.kpi.recortadas': 'Next to a trip: {{n}}',
    'frotaLeve.anomalias.ranking.caminhoes': 'Trucks most often on',
    'frotaLeve.anomalias.ranking.maquinas': 'Machines most often on',
    'frotaLeve.anomalias.ranking.operadores': 'Operators most often on',
    'frotaLeve.anomalias.col.operador': 'Operator',
    'frotaLeve.anomalias.filtro.operador': 'Operator',
    'frotaLeve.anomalias.semMotoristaPesada': 'No driver',
    'frotaLeve.anomalias.semOperador': 'No operator',
    'frotaLeve.anomalias.vazio.pesada': 'No truck on outside a load for this filter',
    'frotaLeve.anomalias.vazio.maquina': 'No machine on outside its schedule for this filter',
    'frotaLeve.anomalias.recorte.pesada': 'Outside the load',
    'frotaLeve.anomalias.recorte.maquina': 'Outside the schedule',
    'frotaLeve.anomalias.recorte.dica.pesada': 'The session touched a HUB load. Only the stretch outside it counts.',
    'frotaLeve.anomalias.recorte.dica.maquina': 'The session touched the period scheduled in the Machinery. Only the stretch outside it counts.',
    'frotaLeve.anomalias.motoristaFonte.cartao': 'From the tracker driver card',
    'frotaLeve.anomalias.motoristaFonte.macro': 'From the driver macro on the tracker',
    'frotaLeve.anomalias.motoristaFonte.conjunto': 'From the truck set in the HUB',
    'frotaLeve.anomalias.motoristaFonte.operador': 'From the machine operator in the Machinery',
    'frotaLeve.anomalias.frente': 'Front {{n}}',
  },
  es: {
    'frotaLeve.anomalias.titulo': 'Anomalía de Flota',
    'frotaLeve.anomalias.eyebrow': 'Gestión',
    'frotaLeve.anomalias.regra': 'Encendido de noche',
    'frotaLeve.anomalias.ajuda': 'Vehículo de la flota liviana clasificada encendido entre las {{de}} y las {{ate}}, en la hora local de donde estaba. El vehículo sin clasificación no entra. Cuenta solo el tramo dentro de la ventana, a partir de {{min}} minutos. La noche es la fecha del inicio de la ventana. Con una posición cada 5 minutos, cada extremo tiene un error de hasta 5 minutos.',
    'frotaLeve.anomalias.ajuda.pesada': 'Camión encendido entre las {{de}} y las {{ate}}, en la hora local de donde estaba, fuera de la carga del HUB. No cuentan la carga, el tránsito y la descarga, los Otros Servicios, la cama baja y el Programado cerca del horario de la carga, con 10 minutos de margen en cada extremo. Cuenta solo el tramo fuera de ellos, a partir de {{min}} minutos.',
    'frotaLeve.anomalias.ajuda.maquina': 'Máquina encendida entre las {{de}} y las {{ate}}, en la hora local de donde estaba, fuera del período programado en la Maquinaria del frente. El período va del primer al último día de cosecha de la máquina, y cubre la madrugada siguiente al último. Cuenta a partir de {{min}} minutos.',
    'frotaLeve.anomalias.kpi.ocorrencias': 'Ocurrencias',
    'frotaLeve.anomalias.kpi.veiculos': 'Vehículos',
    'frotaLeve.anomalias.kpi.horas': 'Horas encendido',
    'frotaLeve.anomalias.kpi.km': 'Km de noche',
    'frotaLeve.anomalias.kpi.semMotorista': 'Sin tarjeta de conductor: {{n}}',
    'frotaLeve.anomalias.grafico.porNoite': 'Por noche',
    'frotaLeve.anomalias.grafico.porHora': 'Por hora local',
    'frotaLeve.anomalias.grafico.ocorrencias': 'Ocurrencias',
    'frotaLeve.anomalias.grafico.minutos': 'Tiempo encendido',
    'frotaLeve.anomalias.grafico.noite': 'Noche del {{dia}}: {{n}} ocurrencias, {{horas}}, {{km}}',
    'frotaLeve.anomalias.grafico.hora': '{{hora}}: {{horas}} encendido',
    'frotaLeve.anomalias.grafico.vazio': 'Ninguna ocurrencia en el período',
    'frotaLeve.anomalias.ranking.veiculos': 'Vehículos más encendidos',
    'frotaLeve.anomalias.ranking.motoristas': 'Conductores más encendidos',
    'frotaLeve.anomalias.ranking.vazio': 'Nada en el período',
    'frotaLeve.anomalias.lista': 'Ocurrencias',
    'frotaLeve.anomalias.vazio': 'Ningún vehículo encendido de noche en este filtro',
    'frotaLeve.anomalias.filtro.de': 'Desde',
    'frotaLeve.anomalias.filtro.ate': 'Hasta',
    'frotaLeve.anomalias.filtro.placa': 'Placa',
    'frotaLeve.anomalias.filtro.classificacao': 'Clasificación',
    'frotaLeve.anomalias.filtro.motorista': 'Conductor',
    'frotaLeve.anomalias.filtro.filial': 'Filial',
    'frotaLeve.anomalias.filtro.todas': 'Todas',
    'frotaLeve.anomalias.col.veiculo': 'Vehículo',
    'frotaLeve.anomalias.col.motorista': 'Conductor',
    'frotaLeve.anomalias.col.noite': 'Noche',
    'frotaLeve.anomalias.col.horario': 'Hora local',
    'frotaLeve.anomalias.col.ligado': 'Encendido',
    'frotaLeve.anomalias.col.km': 'Km',
    'frotaLeve.anomalias.semMotorista': 'Sin tarjeta',
    'frotaLeve.anomalias.semClassificacao': 'Sin clasificación',
    'frotaLeve.anomalias.noite': '{{de}} a {{ate}}',
    'frotaLeve.anomalias.horario': '{{de}} a {{ate}}',
    'frotaLeve.anomalias.km.odometro': 'Por la diferencia del odómetro, en {{pontos}} posiciones',
    'frotaLeve.anomalias.km.rastro': 'Por el rastro de las posiciones, {{pontos}} en el tramo',
    'frotaLeve.anomalias.km.sem': 'Sin km: las posiciones no alcanzaron',
    'frotaLeve.anomalias.fuso.uf': 'Huso por el estado de la posición',
    'frotaLeve.anomalias.fuso.coordenada': 'Huso por la coordenada de la posición',
    'frotaLeve.anomalias.fuso.filial': 'Huso por la filial del registro',
    'frotaLeve.anomalias.fuso.padrao': 'Hora de Brasília, sin posición ni filial',
    'frotaLeve.anomalias.export.dica': 'Descarga las ocurrencias del filtro',
    'frotaLeve.anomalias.export.vazio': 'Ninguna ocurrencia para descargar',
    'frotaLeve.anomalias.vezes': '{{n}}x',
    'frotaLeve.anomalias.aba.pesada': 'Flota Pesada',
    'frotaLeve.anomalias.aba.leve': 'Flota Liviana',
    'frotaLeve.anomalias.aba.maquina': 'Máquina',
    'frotaLeve.anomalias.abas': 'Tipo de flota',
    'frotaLeve.anomalias.kpi.caminhoes': 'Camiones',
    'frotaLeve.anomalias.kpi.maquinas': 'Máquinas',
    'frotaLeve.anomalias.kpi.semMotoristaPesada': 'Sin conductor: {{n}}',
    'frotaLeve.anomalias.kpi.semOperador': 'Sin operador: {{n}}',
    'frotaLeve.anomalias.kpi.recortadas': 'Junto a un viaje: {{n}}',
    'frotaLeve.anomalias.ranking.caminhoes': 'Camiones más encendidos',
    'frotaLeve.anomalias.ranking.maquinas': 'Máquinas más encendidas',
    'frotaLeve.anomalias.ranking.operadores': 'Operadores más encendidos',
    'frotaLeve.anomalias.col.operador': 'Operador',
    'frotaLeve.anomalias.filtro.operador': 'Operador',
    'frotaLeve.anomalias.semMotoristaPesada': 'Sin conductor',
    'frotaLeve.anomalias.semOperador': 'Sin operador',
    'frotaLeve.anomalias.vazio.pesada': 'Ningún camión encendido fuera de la carga en este filtro',
    'frotaLeve.anomalias.vazio.maquina': 'Ninguna máquina encendida fuera de la programación en este filtro',
    'frotaLeve.anomalias.recorte.pesada': 'Fuera de la carga',
    'frotaLeve.anomalias.recorte.maquina': 'Fuera de la programación',
    'frotaLeve.anomalias.recorte.dica.pesada': 'La sesión tocó una carga del HUB. Cuenta solo el tramo fuera de ella.',
    'frotaLeve.anomalias.recorte.dica.maquina': 'La sesión tocó el período programado en la Maquinaria. Cuenta solo el tramo fuera de él.',
    'frotaLeve.anomalias.motoristaFonte.cartao': 'Por la tarjeta del rastreador',
    'frotaLeve.anomalias.motoristaFonte.macro': 'Por la macro del conductor en el rastreador',
    'frotaLeve.anomalias.motoristaFonte.conjunto': 'Por el conjunto del camión en el HUB',
    'frotaLeve.anomalias.motoristaFonte.operador': 'Por el operador de la máquina en la Maquinaria',
    'frotaLeve.anomalias.frente': 'Frente {{n}}',
  },
}
